import {Component} from 'react';
import {Content, Footer, Hero, Preloader} from "../../components";

import card from '../../resources/card.png';
import cardBg from '../../resources/card.jpg';
import close from '../../resources/close.svg';
import logo from '../../resources/logo.svg';
import zvuk from '../../resources/zvuk.svg';
import firstScreen from '../../resources/screen1.jpg';
import secondScreen from '../../resources/screen2.jpg';
import hero from '../../resources/hero.png';
import desktop from '../../resources/desktop.png';
import mobile from '../../resources/mobile.png';
import finish from '../../resources/finish.jpg';
import ear from '../../resources/ear.png';
import quest from '../../resources/quest.png';

import vk from '../../resources/vk.svg';
import ok from '../../resources/ok.svg';
import tg from '../../resources/tg.svg';


export class App extends Component {
    state = {
        loading: true
    }

    componentDidMount() {
        let images = [card, cardBg, close, logo, zvuk, firstScreen, secondScreen, hero, mobile, desktop, finish, vk, ok, tg, ear, quest];
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item,index) => images.push(`${process.env.PUBLIC_URL}/elements/${index}.png`));
        let promises = [];

        images.forEach(image => {
            promises.push(new Promise((resolve, reject) => {
                const newImage = new Image();

                newImage.addEventListener("load", function () {
                    resolve();
                });

                newImage.src = image;
                window[image] = newImage;
            }));
        });

        Promise.all(promises).then(() => {
            this.setState(({loading}) => ({
                loading: !loading
            }));
        });
    }

    render() {
        const currentContent = <>
            <div className="container">
                <Hero/>
                <Content/>
                <Footer/>
            </div>
        </>

        return (
            <div className="wrapper">
                {this.state.loading ? <Preloader/> : currentContent}
            </div>
        );
    }
}